module.exports = __webpack_public_path__ + "static/media/tracey-1.8db93809.wav";